<template>
    <v-card flat :loading="loading">
      <v-list :v-show="showDirectConversations" dense style="max-height: 600px; overflow-y: auto;">
            <v-list-item-group>
              <v-list-item
                v-for="(directConversation) in directConversationsFiltered"
                :key="directConversation.id"
                active-class="active"
                :to="{ name: 'chats', params: { roomType: 'direct', roomId: directConversation.id }}"
                class="chat-direct-message"
                style="display: -webkit-box !important;"
              >
                  <v-list-item-action style="max-width: 10px !important;" class="ml-4">
                    <StatusAvatar :class="directConversation.open ? '' : 'closedAvatar'" :user="dmUser(directConversation)" avatar-size="36px" badge-size="12px"/>
                    <v-badge
                      color="orange"
                      :value="directConversation.unread"
                      offset-x="10"
                      offset-y="-25"
                    >
                      <span slot="badge"> {{ directConversation.unread }} </span>
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                        </div>
                      </template>
                    </v-badge>
                  </v-list-item-action>

                  <v-list-item-content style="margin: 0px !important;min-width: 145px !important;">
                      <v-list-item-title>
                          <span :class="directConversation.unread > 0 ? 'font-weight-bold' : 'font-weight-regular'">{{ directConversation.displayUsername }}</span>
                          &nbsp;<span v-if="!directConversation.open" class="text-caption font-italic red--text">{{ $t('chat.closed') }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle><small :class="directConversation.unread > 0 ? 'font-weight-bold' : 'font-weight-regular'">{{ formatLastMessagePreview(directConversation) }}</small></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action style="margin: 0px !important;" v-if="chatsWrite && directConversation.open">
                      <v-menu style="z-index: 999">
                          <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              icon
                              v-on:click.prevent
                              v-bind="attrs"
                              v-on="on"
                              class="context-menu-btn-direct-message"
                          >
                              <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item
                              v-for="(contextMenu, index) in directConversation.contextMenus()"
                              :key="index"
                              style="display: -webkit-box !important;"
                              class="context-menu-item-direct-message"
                              @click="navDirectChatContextMenu(contextMenu, directConversation)"
                            >
                              <v-list-item-icon>
                              <v-icon :color="contextMenu.color">{{contextMenu.icon}}</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>{{ capitalizeFirstLetter($t(`chat.contextMenu.${contextMenu.key}`)) }}</v-list-item-title>
                            </v-list-item>
                          </v-list>
                      </v-menu>
                  </v-list-item-action>
              </v-list-item>
              <!-- Vuetify directive for infinite scroll / pagination -->
              <v-card v-intersect="infiniteScrolling"></v-card>
              <v-progress-circular
                style="margin: 0px !important;min-width: 185px !important;"
                v-show="loading"
                indeterminate
                color="primary"
              ></v-progress-circular>
          </v-list-item-group>
      </v-list>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import StatusAvatar from '@/components/buddies/status_avatar'
import MixinChatHelper from '@/mixins/chat/helper'
import MixinChatRoomActions from '@/mixins/chat/room_actions'
const emoji = require('node-emoji')

export default {
  name: 'chat-nav_direct_messages_list',
  mixins: [MixinChatHelper, MixinChatRoomActions],
  created () {
    this.getDirectMessages()
  },
  components: { StatusAvatar },
  computed: {
    ...mapGetters({
      users: 'users/listAll',
      buddies: 'users/buddies',
      directConversations: 'chat/directConversations',
      loading: 'chat/directConversationsLoading',
      chatsWrite: 'permissions/chatsWrite',
      presences: 'chat/presences',
      paginationDm: 'chat/paginationDm',
      dmLoaded: 'chat/dmLoaded',
      filterClosed: 'chat/DmFilters/closed',
      filterRead: 'chat/DmFilters/read',
      searchText: 'chat/DmFilters/search'
    }),
    directConversationsFiltered: function () {
      let filteredList = this.directConversations
      // Filter by open / close
      filteredList = filteredList.filter(dmConversation => {
        if (this.filterClosed) {
          return dmConversation?.open
        } else {
          return true
        }
      })
      // Filter by unread
      filteredList = filteredList.filter(dmConversation => {
        if (this.filterRead) {
          return dmConversation?.unread > 0
        } else {
          return true
        }
      })
      // Filter by search
      const searchReg = new RegExp(this.searchText?.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&'), 'i')
      filteredList = filteredList.filter(dmConversation => {
        if (this.searchText) {
          return dmConversation.displayUsername.match(searchReg)
        } else {
          return true
        }
      })
      return filteredList
    },
    showDirectConversations: function () {
      return this.directConversationsFiltered?.length > 0
    }
  },
  methods: {
    ...mapActions({
      getDirectMessages: 'chat/getDirectMessages',
      getMoreDirectMessages: 'chat/getMoreDirectMessages'
    }),
    async infiniteScrolling (entries, observer, isIntersecting) {
      if (isIntersecting && entries.length === 1 && this.directConversations?.length > 1 && !this.dmLoaded) {
        await this.getMoreDirectMessages()
      }
    },
    formatLastMessagePreview (directConversation) {
      const baseMessage = directConversation.formatLastConversationMessagePreview()
      const lastMessageDate = directConversation.getFriendlyLastMessageDate()
      if (baseMessage) {
        let localizedLastMessageDate
        if (lastMessageDate) {
          if (lastMessageDate.text === 'just now') {
            localizedLastMessageDate = this.$t('chat.date.now')
          } else {
            localizedLastMessageDate = this.$tc(`chat.date.${lastMessageDate.interval.unit}`, lastMessageDate.number)
          }
        } else {
          localizedLastMessageDate = this.$t('chat.date.now')
        }
        return emoji.emojify(baseMessage + localizedLastMessageDate)
      } else {
        return ''
      }
    },

    dmUser (dm) {
      const buddyUser = this.buddies.find((user) => user.exten === dm.to_user?.extension)
      if (buddyUser) {
        return buddyUser
      }
      return this.users.find((user) => user.exten === dm.to_user?.extension)
    }
  }
}
</script>

<style scoped>
.active{
  color: #1976d2;
}
.closedAvatar {
  filter: brightness(0.5)
}
</style>
